module.exports = __webpack_public_path__ + "9156ae3c165618b3a48e9b056c75fe61.svg";